import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    IBuyerSendPasswordResetEmailClient,
} from 'interfaceAdapter/gatewaySchemas/IBuyerSendPasswordResetEmailClient';

const PATH = `${API_LOCATION_URL}/buyer/user/send_password_reset_email`;

export class BuyerSendPasswordResetEmailClient implements IBuyerSendPasswordResetEmailClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { email } = input;
        const method = 'POST';
        const headers = {
            'Content-Type': 'application/json',
        };
        const body = JSON.stringify({ email });
        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });
            return response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
